var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-pills__pill"},[_c('button',{staticClass:"m-pills__close-btn",attrs:{"title":"Enlever"},on:{"click":_vm.close}}),_c('span',{staticClass:"m-pills__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }